export function unformatPhrase(str?: string): string {
  return str?.replaceAll(/[<>]/g, '') ?? ''
}
